import StickyBox from 'react-sticky-box';
import ExerciseFilters from './ExerciseFilters';
import ExerciseCard from './ExerciseCard';
import ExerciseLibraryNav from './ExerciseLibraryNav';

import '../assets/scss/exercise-library.scss';

const ExerciseLibrary = () => {
  return (
    <div className="fiterr-app-section">
      <div className="fiterr-app-inner-wrapper page-layout-left-column">
        <div className="fiterr-app-col-wrapper col-left">
          <StickyBox offsetTop={100} offsetBottom={10} className="col-left-filters-container">
            <ExerciseFilters />
          </StickyBox>
        </div>
        <div className="fiterr-app-col-wrapper col-right">
          <ExerciseLibraryNav />
          <div className="col-right-content-container">
            <ExerciseCard />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExerciseLibrary;